var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkthroughStatBoxes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.55933,
    y: 1.91309,
    width: 32,
    height: 32,
    stroke: "#151515",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4593 25.9131V22.9131H11.1793V20.9731L17.6193 11.9531H20.1193V20.8331H21.8393V22.9131H20.1193V25.9131H17.4593ZM13.8993 20.8331H17.4593V15.8531L13.8993 20.8331Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkthroughStatBoxes);
export default __webpack_public_path__ + "static/media/walkthrough-stat-boxes.1f7ec02190d275f2227e5a3163d32137.svg";
export { ForwardRef as ReactComponent };